// 进水水质分析
import React from "react";
import * as echarts from "echarts/lib/echarts";
import moment from "moment";

let myChart = null;
class Charts extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <div
        id="charts"
        style={{ width: "100%", height: this.props.height }}
      ></div>
    );
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    myChart = !myChart
      ? echarts.init(document.getElementById("charts"))
      : myChart;

    const {
      xAxisData,
      patrolnumberArr,
      patrolitemnumberArr,
      normalnumberArr,
      abnormalnumberArr,
      leaknumberArr,
    } = nextProps.data;

    const option = {
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "shadow",
        },
      },
      xAxis: {
        type: "category",
        data: xAxisData,
      },
      yAxis: {
        type: "value",
      },
      series: [
        {
          name: "巡检次数",
          type: "bar",
          data: patrolnumberArr,
          label: {
            show: true,
            position: "top",
          },
        },
        {
          name: "巡检项数量",
          type: "bar",
          data: patrolitemnumberArr,
          label: {
            show: true,
            position: "top",
          },
        },
        {
          name: "正常",
          type: "bar",
          data: normalnumberArr,
          label: {
            show: true,
            position: "top",
          },
        },
        {
          name: "异常运行",
          type: "bar",
          data: abnormalnumberArr,
          label: {
            show: true,
            position: "top",
          },
        },
        {
          name: "漏检",
          type: "bar",
          data: leaknumberArr,
          label: {
            show: true,
            position: "top",
          },
        },
      ],
    };
    myChart.setOption(option);
    window.addEventListener("resize", this.resizeFn);
  }

  resizeFn() {
    myChart.resize();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.resizeFn);
    myChart = null;
  }
}

export default Charts;
